<template>
  <section
    id="qz-cta"
    class="qz-cta"
  >
    <h1 class="qz-cta__title mb-4">{{ title }}</h1>
    <div
      v-if="$slots.actions"
      class="qz-cta__actions"
    >
      <slot name="actions" />
    </div>
    <template v-if="$slots.firstStepNote && currentStep === 1">
      <slot name="firstStepNote" />
    </template>
    <template
      v-if="$slots.firstStepInfo && currentStep === 1"
    >
      <help-text class="px-6 py-2 mb-8">
        <slot name="firstStepInfo" />
      </help-text>
    </template>
  </section>
</template>

<script>
import HelpText from '@/components/HelpText/HelpText.vue';

export default {
  name: 'qz-cta',
  components: {
    HelpText,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    currentStep: {
      type: Number,
      required: true,
    },
    timerDuration: {
      type: Number,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.qz-cta {
  padding: 0 10px;

  &::v-deep .help-text {
    font-size: 0.875rem;
  }

  &__title {
    font-size: 24px;
    line-height: 1em;
    font-weight: 500;
    color: var(--v-title-colour-base, $clr-black);
    & + * { margin-top: 18px; }
  }

  &__actions {
    font-size: 24px;
    line-height: 36px;
    font-weight: 500;
    color: var(--v-navy-dark-base, $clr-navy-dark);

    a {
      text-decoration: underline;
      color: var(--v-primary-base, $clr-primary);

      &:hover { text-decoration: none; }
    }
  }
}

@media screen and (min-width: 601px) {
  .qz-cta {
    padding: 0;

    &__title {
      font-size: 36px;
    }
  }
}
</style>
